module.exports = __webpack_public_path__ + "static/media/cwiczenie-pisania-na-klawiaturze-inf1-4.12e56e79.png";